import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const lang =
  document.getElementsByTagName("html")[0].getAttribute("lang") || "cs";

const i18n = new VueI18n({
  locale: lang,
  pluralizationRules: {
    /**
     * @param choice {number} a choice index given by the input to $tc: `$tc('path.to.rule', choiceIndex)`
     * @param choicesLength {number} an overall amount of available choices
     * @returns a final choice index to select plural word by
     */
    cs: function(choice) {
      // this === VueI18n instance, so the locale property also exists here

      if (choice < 2) {
        return 0;
      } else if (choice < 5) {
        return 1;
      } else {
        return 2;
      }
    }
  }
});

export default i18n;
